import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import styles from "./item-image.module.css";
import { FallbackItemImage } from "@coworker/apprestructured/src/shared/components/FallbackItemImage/FallbackItemImage";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import ImageStrikeThroughIconPath from "@ingka/ssr-icon/paths/image-strikethrough";
import { SVGProps } from "react";
import { getSmallThumbnailImageUrl } from "../../../helpers/image.url.helper";

interface ItemImageProps {
  imageUrl: string;
  fallbackImageIcon?: (prefix?: string | undefined) => SVGProps<SVGElement>[];
}

export const ItemImage = ({
  imageUrl,
  fallbackImageIcon = ImageStrikeThroughIconPath,
}: ItemImageProps) => {
  if (imageUrl && imageUrl !== "") {
    return (
      <FixaImage
        className={styles["item-image-container"] ?? ""}
        src={getSmallThumbnailImageUrl(imageUrl)}
      />
    );
  }
  return (
    <FallbackItemImage
      classname={styles["fallback-item-image-container"] || ""}
    >
      <FixaSSRIcon paths={fallbackImageIcon} />
    </FallbackItemImage>
  );
};
